const documentIsAvailable = typeof document !== 'undefined';

export default documentIsAvailable;
